<!--
  Why the task being worked holds this record — shown in the record header while it is open.

  The second pass hands out records that the boxing already finished, and the only way to know
  what to do on one is the sentence the queue row carried: which chips are unsettled, which two
  copies of one photograph disagree. Making the annotator remember it from the queue page, or
  go back to read it, is the friction this removes.

  The text is the server's, as the queue last loaded it (`queue.reasonsFor`); nothing is derived
  here. It is a snapshot — it refreshes when the queue does, which complete-and-advance and the
  queue page both trigger — and says so, so a fixed chip still listed is not read as a fix that
  did not land. Absent when there is nothing to say: a record from another task, a record not on
  the loaded page, or one the second pass has no reason to hold.

  Text, not colour: a heading and a list, in a note.
-->
<script lang="ts">
  import { queue } from '../lib/stores/queue.svelte';

  interface Props {
    inscriptionId: number | null;
  }

  const { inscriptionId }: Props = $props();

  const reasons = $derived(queue.reasonsFor(inscriptionId));
  const label = $derived(queue.task?.label ?? 'This task');
</script>

{#if reasons.length}
  <div class="queue-reasons banner info small col" role="note" aria-labelledby="queue-reasons-title">
    <strong id="queue-reasons-title">{label}: why this record is here</strong>
    <ul>
      {#each reasons as reason, index (index)}
        <li>{reason}</li>
      {/each}
    </ul>
    <p class="muted">As of when the queue last loaded; it refreshes when you move on.</p>
  </div>
{/if}

<style>
  .queue-reasons {
    gap: 4px;
  }

  ul {
    margin: 0;
    padding-left: 18px;
    overflow-wrap: anywhere;
  }

  ul li + li {
    margin-top: 2px;
  }

  p {
    margin: 0;
  }
</style>
